import { render } from "./Home.vue?vue&type=template&id=98f9aada&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=98f9aada&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-98f9aada"

export default script